import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from '../Header';
import { Link } from 'react-router-dom';

// Define styles as JavaScript objects
const isSmallScreen = window.innerWidth <= 600;
const styles = {
  radheExchange: {
    fontFamily: 'Arial, sans-serif',
    position: 'sticky',
    top: 0,
    zIndex: 99,
    width: '100%'
  },
  headerContainer: {
    background: 'linear-gradient(180deg,rgb(0, 66, 92) 0%, rgb(51, 147, 186) 50%, rgb(103, 205, 246) 100%)',
    color: 'white'
  },
  //   logo: {
  //     padding: '5px 0'
  //   },
  demoAccountDiv: {
    position: 'relative',
  },
  demoAccountBtn: {
    backgroundColor: '#ff0000',
    color: 'white',
    position: 'absolute',
    bottom: isSmallScreen ? 24 : 25,
    border: 'none',
    borderRadius: '4px',
    padding: isSmallScreen ? '1px 2px' : '3px 30px',
    fontSize: isSmallScreen ? '8px' : '13px',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
  },
  accountInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: '2px'
  },
  balanceBox: {
    background: 'linear-gradient(#5ecbdd, #146578)',
    width: "100px",
    borderRadius: '10px',
    padding: '3px 5px',
    border: "1px solid white",
    color: "white",
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  expBox: {
    background: 'linear-gradient(#5ecbdd, #146578)',
    borderRadius: '10px',
    width: "100px",
    padding: '3px 5px',
    border: "1px solid white",
    color: "white",
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  bettingNavbar: {
    backgroundColor: '#005762',
    padding: '0'
  },
  navbarNav: {
    width: '100%',
    display: 'flex',
    background: 'rgb(0, 87, 98)',
    flexWrap: 'nowrap',
    overflowX: 'auto'
  },
  navItem: {
    whiteSpace: 'nowrap'
  },
  navLink: {
    color: 'white',
    padding: '12px 10px',
    position: 'relative',
    fontSize: '14px',
    transition: 'background-color 0.2s'
  },
  navLinkHover: {
    backgroundColor: '#00727e'
  },
  liveBadge: {
    position: 'relative',
    fontSize: '10px',
    backgroundColor: '#ff0000',
    color: 'white',
    padding: '1px 3px',
    borderRadius: '3px',
    marginLeft: '5px',
    top: '-16px',
    left: "-21px",
  },
  liveCount: {
    display: 'inline-block',
    backgroundColor: 'white',
    color: '#ff0000',
    borderRadius: '50%',
    width: '14px',
    height: '14px',
    fontSize: '9px',
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '14px',
    marginLeft: '2px'
  },
  mainContent: {
    backgroundColor: '#f5f5f5',
    minHeight: 'calc(100vh - 130px)',
    padding: '20px 0'
  },
  contentPlaceholder: {
    backgroundColor: 'white',
    borderRadius: '5px',
    minHeight: '400px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
  }
};

// Add CSS to handle responsive design
const addResponsiveCSS = () => {
  const css = `
    @media (max-width: 992px) {
      .betting-navbar .navbar-nav {
        flex-direction: column !important;
      }
      
      .account-info {
        justify-content: center !important;
        margin-top: 10px !important;
      }
      
      .header-container .row {
        flex-direction: row !important;
      }
      
      .header-container .col-md-4 {
        text-align: center !important;
        margin-bottom: 10px !important;
      }
    }
  `;

  const styleElement = document.createElement('style');
  styleElement.innerHTML = css;
  document.head.appendChild(styleElement);

  return () => {
    document.head.removeChild(styleElement);
  };
};

const TopBar = () => {
  React.useEffect(() => {
    // Add responsive styles when component mounts
    const cleanup = addResponsiveCSS();

    // Remove styles when component unmounts
    return cleanup;
  }, []);

  return (
    <div style={styles.radheExchange}>
      {/* Header section */}
      <div style={styles.headerContainer} className="header-container">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-4 col-4 mb-0 py-1">
              <div _ngcontent-jrx-c79="" className="sidebar-header" style={{ display: "flex !important" }}>

                <a
                  _ngcontent-jrx-c79=""
                  routerlink="/home"
                  className="d-flex align-items-center"
                  style={{ textDecoration: "none" }}
                  href="/"
                >
                  <img
                    _ngcontent-jrx-c79=""
                    className="top_dark"
                    src="/assets/all_images/sidebar/KheloyarLogoo.png"
                    alt="Logo_Kheloyaar360"
                  />
                </a>
              </div>
            </div>
            <div className="col-md-4 col-4 mb-0 text-center" style={styles.demoAccountDiv}>
              <button style={styles.demoAccountBtn}>Demo Account</button>
            </div>
            <div className="col-md-4 col-4 mb-0 py-1">
              <div style={styles.accountInfo} className="account-info">
                <button className="ms-auto text-center" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style={styles.balanceBox}>
                  <span>2000.00</span>
                </button>
                <button className="ms-auto text-center" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style={styles.expBox}>
                  <span>Exp: 0.00</span>
                </button>
              </div>

              {/* <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Toggle right offcanvas</button> */}

              <div class="offcanvas offcanvas-end" style={{width:"330px"}} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div class="offcanvas-header">
                  <h5 id="offcanvasRightLabel">Offcanvas right</h5>
                  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                  ...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;